/**
 * Invoke an array of promises in serial, passing the result of each promise to the next.
 */
var Q = require('q');

function Serializer() {
	this.functions = [];
}

Serializer.prototype.queue = function (fn) {
	this.functions.push(fn);
};

Serializer.prototype.execute = function () {
	var functions = this.functions,
		deferred = (this._deferred = Q.defer());

	if (functions.length === 1) {
		functions[0]().then(deferred.resolve, deferred.reject);
	} else if (!functions.length) {
		return Q.resolve();
	} else {
		functions
			.reduce(function (prev, curr) {
				if (typeof prev === 'function') {
					var prevResult = prev();

					if (prevResult && typeof prevResult.then === 'function') {
						return prevResult.then(curr);
					} else {
						return Q(curr(prevResult));
					}
				} else if (prev && typeof prev.then === 'function') {
					return prev.then(curr);
				} else {
					return Q(curr(prev));
				}
			})
			.then(deferred.resolve, deferred.reject);
	}

	return deferred.promise;
};

module.exports = Serializer;
